import { Row, Col, Table } from 'antd';
import { VIEWS } from '../../../utils/emailUtils';
import moment from 'moment';

const
{ MODAL } = VIEWS,
DATE_FORMAT = 'YYYY-MMM-DD';

export default class EmailResults extends React.Component {
    constructor(props) { super(props);
  }

    onChange = (pagination, filters, sorter) => {
                const { services, values } = this.props,
                { paged } = this.props.pagination;
                services.storePagination(pagination.current, pagination.pageSize);
                if (paged == 1) {
                    services.getEmailsBySearch({...values, pageSize: pagination.pageSize, pageNum: pagination.current });
                }
              }

    render() {
        const { services, controls, searchingMessages, table, role, pagination } = this.props,
        columns = [{
            title: 'TR ID',
            dataIndex: 'trId',
            key: 'trId',
            sorter: (a, b) => a.trId == null || b.trId == null ? true : (a.trId - b.trId)
        }, {
            title: role == 'd' ? 'Endorsee' : 'Student',
            dataIndex: 'studentName',
            key: 'studentName',
            sorter: (a, b) => a.studentName == null || b.studentName == null ? true : a.studentName.localeCompare(b.studentName)
        }, {
            title: 'Recipient(s)',
            key: 'recipients',
            sorter: (a, b) =>  a.recipients == null || b.recipients == null ? true : a.recipients.localeCompare(b.recipients),
            render: (record, index) => record.recipients == null ? '' :
              record.recipients.split(';').map(r => {
                let array = r.split(':');
                if(array.length === 3) return `${array[1]} <${array[2]}>; `;
                else if(array[0]) return (array[0] + "; ");
            })
        }, {
            title: 'Subject',
            dataIndex: 'subject',
            key: 'subject',
            sorter: (a, b) => a.subject == null || b.subject == null ? true : a.subject.localeCompare(b.subject)
        }, {
            title: 'Date Sent',
            dataIndex: 'dateSent',
            key: 'dateSent',
            sorter: (a, b) => a.dateSent == null || b.dateSent == null ? true
                : ( a.dateSent - b.dateSent),
            render: r => (
                <span>
                    {!r ? null : moment(r).local().format(DATE_FORMAT)}
                </span>
            )
        }];

        return (
          <Row type='flex' justify='space-around' align='middle'>
              <Col span={23}>
                  <div className='provider-table-card provider-border-accent'>
                    {pagination.totalCount > 4000 ?<font color={'red'}>A maximum of 4000 emails can be returned. 
                    Please refine your search criteria.</font> : ''}
                      <Row type='flex' justify='space-around' align='middle' style={{ marginBottom: '20px' }}>
                          <Col span={24}>
                              <Table
                                  locale={{ emptyText: '' }}
                                  size='medium'
                                  bordered={false}
                                  columns={columns}
                                  dataSource={table}
                                  loading={searchingMessages}
                                  pagination={{  size: 'small',
                                                showSizeChanger: true,
                                                current: pagination.pageNum,
                                                pageSize: pagination.pageSize,
                                                showTotal: ( ( total, range ) => `${ range[ 0 ]}-${ range[ 1 ]} of ${ total } items` )
                                              }}
                                  onChange= {this.onChange}
                                  onRow={r => ({
                                      onClick: () => {
                                          services.getEmail(r.emailId);
                                          controls.changeView(MODAL);
                                      }
                                  })}
                              />
                          </Col>
                      </Row>
                  </div>
              </Col>
          </Row>
        );
    }
}
